<template>
    <div class="vstack">
        <p class="numeric">
            {{ position.end }}
        </p>
        <span class="lines-vertical"></span>
        <p class="numeric">
            {{ position.length }}
        </p>
        <span class="lines-vertical"></span>
        <p class="numeric">
            {{ position.start }}
        </p>
    </div>
</template>

<script lang="ts">
import { ResumeExperiencePosition } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "experience-position-timeline",
    props: {
        position: {
            type: Object as PropType<ResumeExperiencePosition>,
            required: true
        } 
    }
})
</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

.vstack {
    display: flex
    align-items center
    flex-direction column
    gap: 4pt
}

p {
    text-align: center
}

</style>